<div class="custom-message">
  @if (messageTemplate) {
    <span class="flex justify-center items-center gap-2">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <mask
          id="mask0_17204_34038"
          style="mask-type: alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="16"
          height="16"
        >
          <rect width="16" height="16" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_17204_34038)">
          <path
            d="M7.06536 11.0668L11.7654 6.36683L10.832 5.4335L7.06536 9.20016L5.16536 7.30016L4.23203 8.2335L7.06536 11.0668ZM7.9987 14.6668C7.07648 14.6668 6.20981 14.4918 5.3987 14.1418C4.58759 13.7918 3.88203 13.3168 3.28203 12.7168C2.68203 12.1168 2.20703 11.4113 1.85703 10.6002C1.50703 9.78905 1.33203 8.92238 1.33203 8.00016C1.33203 7.07794 1.50703 6.21127 1.85703 5.40016C2.20703 4.58905 2.68203 3.8835 3.28203 3.2835C3.88203 2.6835 4.58759 2.2085 5.3987 1.8585C6.20981 1.5085 7.07648 1.3335 7.9987 1.3335C8.92092 1.3335 9.78759 1.5085 10.5987 1.8585C11.4098 2.2085 12.1154 2.6835 12.7154 3.2835C13.3154 3.8835 13.7904 4.58905 14.1404 5.40016C14.4904 6.21127 14.6654 7.07794 14.6654 8.00016C14.6654 8.92238 14.4904 9.78905 14.1404 10.6002C13.7904 11.4113 13.3154 12.1168 12.7154 12.7168C12.1154 13.3168 11.4098 13.7918 10.5987 14.1418C9.78759 14.4918 8.92092 14.6668 7.9987 14.6668Z"
            fill="#0D9443"
          />
        </g>
      </svg>
      <ng-container *ngTemplateOutlet="messageTemplate"></ng-container>
    </span>
  } @else {
    <span>{{ messageText }}</span>
  }
</div>
